const resources = {
    overview: 'Aperçu'
};

export default function getResource(label) {
    return resources[label];
}
